import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const playersSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.PLAYERS_FILTERS}`,
        popover: {
            title: "Filter & Tournament",
            description:
                "Use the position filter to show only specific roles, and the tournament picker " +
                "to switch between competitions. The entire roster updates instantly.",
            side: "bottom",
            align: "end",
        },
    },
    {
        element: `#${ONBOARDING_IDS.PLAYERS_SORT}`,
        popover: {
            title: "Sort Players",
            description:
                "Click these buttons to reorder the roster by name, average KPI, or position. " +
                "Click the same button again to toggle between ascending and descending order.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.PLAYERS_GOALKEEPERS}`,
        popover: {
            title: "Your Roster",
            description:
                "The roster is split into Goalkeepers and Field Players. " +
                "Each card shows the player's average KPI, role, and last opponent. " +
                "Click any card to open their full profile with detailed analytics.",
            side: "bottom",
            align: "center",
        },
    },
    {
        element: `#${ONBOARDING_IDS.PLAYERS_GOALKEEPERS} > div:first-child`,
        popover: {
            title: "Player Card",
            description:
                "The top-performing player gets a highlighted card with a star. " +
                "Cards are colour-coded by KPI tier — green is elite, red needs attention. " +
                "Click to dive into that player's full performance breakdown.",
            side: "right",
            align: "start",
        },
    },
];
